// extracted by mini-css-extract-plugin
module.exports = {"label-container":"_6bf55ce5dc--label-container--vskUj"};